import fetchRequest from "./index";
import {
  GET_BANNERS,
  GET_FOOTER_MENU,
  GET_HEADER,
  GET_HEADER_NAV_MAIN,
  GET_RGPBANNER,
  GET_WEATHER_MEETING,
  GET_WEATHER,
} from "./query";

// import mockFooterMenu from "public/test_data/FooterMenu.json";
// import mockRGPBanner from "public/test_data/RGPBanner.json";
// import mockHeader from "public/test_data/Header.json";
// import mockHeaderNavMain from "public/test_data/HeaderNavMain.json";
// import mockSummary from "public/test_data/Summary_test.json";
// import mockWeather from "public/test_data/Weather.json";
import { LangCode } from "../utils/LanguageContext";

export const CMS = "cms";
export const QIDS = "qids";

export const getWeatherData = async () => {
  return await fetchRequest(
    null,
    GET_WEATHER,
    QIDS,
    undefined,
    undefined,
    false
  );
};

export const getFooterMenu = async (options: any) => {
  const variables = {
    path: "/sitecore/content/Sites/JCRW/SiteConfiguration/Footer",
    ...options,
  };
  return await fetchRequest(
    variables,
    GET_FOOTER_MENU,
    CMS,
    undefined,
    undefined,
    false
  );
};

export const getRGPBanner = async (options: any) => {
  const variables = {
    path: "/sitecore/content/Sites/CorpWebCommon/RGP/02-Racing",
    ...options,
  };
  return await fetchRequest(
    variables,
    GET_RGPBANNER,
    CMS,
    undefined,
    undefined,
    false
  );
};

export const getHeader = async (options: any) => {
  const variables = {
    path: "/sitecore/content/Sites/JCRW/SiteConfiguration/Header",
    ...options,
  };
  return await fetchRequest(variables, GET_HEADER, CMS, undefined);
};
export const getHeaderNavMain = async (options: any) => {
  const variables = {
    path: "/sitecore/content/Sites/CorpWebCommon/InformationArchitercutre/",
    ...options,
  };
  return await fetchRequest(
    variables,
    GET_HEADER_NAV_MAIN,
    CMS,
    undefined,
    undefined,
    false
  );
};
export const getWeatherMeeting = async () => {
  const variables = {
    localSim: "LOCAL",
    status: [
      "DECLARED",
      "DEFINED",
      "STARTED",
      "CLOSED",
      "ABANDON_PARTIAL",
      "ABANDON"
    ],
  };
  return await fetchRequest(
    variables,
    GET_WEATHER_MEETING,
    QIDS,
    undefined,
    undefined,
    false
  );
};
export const getBanners = async (
  lang: LangCode,
  bannerType: "Top" | "Bottom" | "Middle"
) => {
  let bannerPath = "";
  switch (bannerType) {
    case "Top":
      bannerPath = "TopBanners";
      break;
    case "Middle":
      bannerPath = "BannerWithText";
      break;
    case "Bottom":
      bannerPath = "BottomCarnivalBanners";
      break;
    default:
      break;
  }

  const variables = {
    path: `/sitecore/content/Sites/JCRW/Banners/Simulcast/${bannerPath}`,
    language: lang,
  };
  return await fetchRequest(variables, GET_BANNERS, "cms");
};
